<template>
    <div class="layout">
      <AppHeader />
  
      <main class="layout-main">
        <slot />
      </main>
  
      <AppFooter />
    </div>
  </template>
  
  <script>
  import AppHeader from '@/components/AppHeader.vue'
  import AppFooter from '@/components/AppFooter.vue'
  
  export default {
    name: 'AppLayout',
    components: { AppHeader, AppFooter },
  }
  </script>
  
  <style scoped>
  .layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }
  
  .layout-main {
    flex: 1;
    background: #ffffff;
  }
  </style>